<template>
	<div class="root">
		<TableBlock ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="270">
			<div class="common-space-between">
				<div class="common-items-center">
					<el-input v-model="param.keyword" ref="keyWord" style="width:150px;margin-right:10px;" :size="this.$store.state.btnSize" placeholder="请输入版本号"></el-input>
					<el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize" @click="searchBtn">搜索</el-button>
					<el-button class="btn-heigth" type="danger" icon="el-icon-refresh" :size="this.$store.state.btnSize" @click="resetBtn">重置</el-button>
				</div>
				<div>
					<el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
				</div>
			</div>
		</TableBlock>
		<AddBlock ref="add"></AddBlock>
	</div>
</template>
<script>
import { operate } from '@/utils/config'
import { getFun } from '@/utils/httpFun'
import Month from '@/components/component-block/block-month.vue'
import AddBlock from './add-block-app.vue'
import { columns } from './index.js'
export default {
	components: {
		Month: Month,
		AddBlock: AddBlock
	},
	data() {
		return {
			cloumn: [],
			action: operate.APPLIST,
			param: {
				release:"",
			}
		};
	},
	created() {
		this.cloumn = columns(this);
	},
	mounted() {

	},
	methods: {

		searchBtn() {
			this.$refs.tableData.getDatas()
		},
		resetBtn() {
			this.param.release = null
			this.$refs.tableData.resetHttp()
		},
		

		//编辑
		eidtBtn(ev) {
			    ev.mark = "eidt"
			this.$refs.add.showMessage(ev);
		},
	
		//添加 
		addBtn(ev) {
			let list = {
				mark:"add"
			} 
			this.$refs.add.showMessage(list)
		}
	}
}
</script>

<style lang="scss" scoped></style>